<template>
  <div>
    <v-form ref="beneficiario">
      <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete label="Status" :items="[
            { text: 'Activo', value: 1 },
            { text: 'Inactivo', value: 2 }
          ]" item-text="text" item-value="value" v-model="form.status" :readonly="readOnly" color="#00a7e4" outlined
            :rules="[(value) => value !== null && value !== undefined || 'Campo Requerido']"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field label="Nombre" v-model="form.nombre" primary color="#00a7e4" type="text" outlined
            :readonly="readOnly" :rules="required"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field label="Apellido paterno" v-model="form.apellido_paterno" primary color="#00a7e4" type="text"
            outlined :readonly="readOnly" :rules="required"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field label="Apellido materno" v-model="form.apellido_materno" primary color="#00a7e4" type="text"
            outlined :readonly="readOnly" :rules="required"></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field label="Fecha Nacimiento" v-model="form.fecha_nacimiento" type="date" outlined />
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete label="Genero" :items="generoList" item-text="name" item-value="id" v-model="form.genero"
            primary color="#00a7e4" type="text" :readonly="readOnly" outlined :rules="required"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete label="Estado Civil" placeholder="Requerido"
            :items="['Soltero(a)', 'Casado(a)', 'Unión Libre']" color="#00a7e4" type="text" v-model="form.estado_civil"
            primary outlined :readonly="readOnly" :rules="required"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field label="RFC" v-model="form.rfc" placeholder="Requerido" v-mask="'XXXX######XXX'" color="#00a7e4"
            type="text" :readonly="readOnly" outlined>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <CommonEmailAutocomplete :emailEdit="form.correo" :readOnly="readOnly"
            @emailUpdate="(e) => (form.correo = e)">
          </CommonEmailAutocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field label="Teléfono" placeholder="##########" v-mask="'##########'" :rules="required"
            v-model="form.telefono" outlined primary :readonly="readOnly" color="#00a7e4"></v-text-field>
        </v-col>
        <!-- <v-col cols="12" md="4" v-if="form.parentesco == 9">
          <v-text-field
            label="Especifica el parentesco"
            v-model="form.otroParentesco"
            outlined
            :rules="required"
            :readonly="readOnly"
            color="#00a7e4"
          ></v-text-field>
        </v-col> -->
        <v-col cols="12" md="4" v-if="showEsFamiliar">
          <v-checkbox v-model="form.es_familiar" :disabled="!rules.puedeSerFamiliar" :rules="[onlyOneCheckRule]"
            label="¿Es familiar?" color="#00a7e4" />
        </v-col>
        <v-col cols="12" md="4" v-if="maxPorcentajePosible > 0">
          <v-checkbox v-model="form.es_beneficiario" :rules="[onlyOneCheckRule]" label="¿Es beneficiario?"
            color="#00a7e4" :disabled="!rules.puedeSerBeneficiario || maxPorcentajePosible <= 0"></v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete label="Parentesco" :rules="required" :items="parentescoList" item-text="nombre"
            item-value="id" v-model="form.parentesco" outlined :readonly="readOnly" :disabled="!algunCheckSeleccionado" primary
            color="#00a7e4"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4" v-if="form.es_beneficiario">
          <v-text-field label="Porcentaje" :rules="[
            ...(es_beneficiario ? required : []),
            (v) =>
              !es_beneficiario || v <= maxPorcentajePosible ||
              'El valor no puede ser mayor a ' + maxPorcentajePosible,
          ]" v-model="form.porcentaje" type="number" outlined primary :readonly="readOnly" color="#00a7e4"
            :hint="'Puedes ingresar hasta el ' + maxPorcentajePosible + '%'"></v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>

const ESCENARIO_RULES = {
  SOLO_FAMILIARES: {
    puedeSerFamiliar: true,
    puedeSerBeneficiario: false,
    mostrarPorcentaje: false,
    checkedFamiliar: true,
    checkedBeneficiario: false,
    filtroParentesco: p => p.familiar === true,
    defaultEstado: { es_familiar: true, es_beneficiario: false }
  },

  FAMILIARES_Y_BENEFICIARIOS: {
    puedeSerFamiliar: true,
    puedeSerBeneficiario: true,
    checkedFamiliar: false,
    checkedBeneficiario: false,
    mostrarPorcentaje: form => form.es_beneficiario,
    filtroParentesco: (p, form) =>
      form.es_beneficiario ? p.beneficiario === true : p.familiar === true,
    defaultEstado: { es_familiar: false, es_beneficiario: false }
  },

  SOLO_BENEFICIARIOS: {
    puedeSerFamiliar: false,
    puedeSerBeneficiario: true,
    mostrarPorcentaje: true,
    checkedFamiliar: false,
    checkedBeneficiario: true,
    filtroParentesco: p => p.beneficiario === true,
    defaultEstado: { es_familiar: false, es_beneficiario: true }
  }
};
import CommonEmailAutocomplete from "@/components/commonComponents/CommonEmailAutocomplete.vue";
import RfcFacil from "rfc-facil";
import moment from "moment";
import { getParentescoListByAlianzaOrGetNulls } from "@/services/beneficiarios/benefiario.service.js";

export default {
  components: {
    CommonEmailAutocomplete,
  },
  data: () => {
    return {
      required: [(value) => !!value || "Campo Requerido"],
      dialog: false,
      parentescosRaw: [],
      diferencia_porcentaje: 100,
      form: {
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        fecha_nacimiento: null,
        genero: null,
        estado_civil: null,
        rfc: null,
        correo: null,
        telefono: null,
        parentesco: null,
        otroParentesco: null,
        es_beneficiario: false,
        es_familiar: false,
        porcentaje: null,
        status: 1
      },
      generoList: [
        {
          id: "M",
          name: "Masculino",
        },
        {
          id: "F",
          name: "Femenino",
        },
      ],
      rfcRules: [
        (v) =>
          (v || "").length <= 13 || "RFC no debe ser mayor de 13 caracteres",
        (v) => !!v || "Campo Requerido",
        (v) =>
          /^([A-ZÑ&]{3,4})([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])([A-Z\d]{3})?$/.test(
            v
          ) || "RFC no es válido, recordar escribir en mayúsculas",
      ],
      es_beneficiario: false,
      showEsFamiliar: true
    };
  },
  props: {
    toSave: {
      type: Boolean,
      default: false,
    },
    currentPorcentaje: {
      type: Number,
      default: 100,
    },
    alianzaId: {
      type: Number,
      default: null,
    },
    product: {
      type: Object,
      default: null,
    },
    beneficiariosList: Array,
    beneficiarioId: {
      type: Number,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    beneficioEdicion: {
      type: Object,
      default: () => ({}),
    },
    limiteFam: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'form.es_familiar'(val) {
      if (val) {
        this.form.es_beneficiario = false
        this.form.porcentaje = null
        this.form.parentesco = null;
      }
    },
    'form.es_beneficiario'(val) {
      if (val) {
        this.form.porcentaje = null
        this.form.parentesco = null;
        this.form.es_familiar = false
      }
    },
    escenario: {
      immediate: true,
      handler(esc) {
        const defaults = ESCENARIO_RULES[esc]?.defaultEstado
        if (defaults) Object.assign(this.form, defaults)
      }
    },
    alianzaId: {
      handler(id) {
        if (id) this.getParentescoList();
      },
      immediate: true
    },
    product: {
      handler() {
        this.parentescosRaw = [...this.parentescosRaw];
        this.form.es_familiar = this.rules.checkedFamiliar
        this.form.es_beneficiario = this.rules.checkedBeneficiario
      },
      immediate: true
    },
    sinCupoFamiliares: {
      immediate: true,
      handler(val, oldVal) {
        if (!this.esCrearBeneficiario) return
        if ((this.product?.limiteFamiliares || 0) === 0) return;
        if (!val || oldVal) return
        this.showWarnModal(
          'Ya se alcanzó el límite de familiares permitido para este producto'
        )
        this.form.es_familiar = false
      }
    },

    sinCupoBeneficiarios: {
      immediate: true,
      handler(val, oldVal) {
        if (!this.esCrearBeneficiario) return
        if ((this.product?.limiteBeneficiarios || 0) === 0) return;
        if (!val || oldVal) return
        this.showWarnModal(
          'Ya se alcanzó el límite de beneficiarios permitido para este producto'
        )
        this.form.es_beneficiario = false
        this.form.porcentaje = null
      }
    },
    "form.fecha_nacimiento"() {
      this.actualizarRfc();
    },
    "form.nombre"() {
      this.actualizarRfc();
    },
    "form.apellido_paterno"() {
      this.actualizarRfc();
    },
    "form.apellido_materno"() {
      this.actualizarRfc();
    },
    toSave(val) {
      if (val) {
        const isValid = this.$refs.beneficiario.validate();
        const formToSend = { ...this.form };
        if (formToSend.parentesco == 9) {
          delete formToSend.parentesco;
        }
        this.$emit("goTosave", isValid, formToSend);
      }
    },
    beneficioEdicion() {
      this.form = { ...this.beneficioEdicion };
    },
    form: {
      handler(newVal) {
        this.$emit('form-updated', newVal)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    sinCupoFamiliares() {
      const limite = this.product?.limiteFamiliares ?? 0
      const usados = this.beneficiariosList?.filter(b => b.es_familiar).length || 0
      return usados >= limite
    },

    sinCupoBeneficiarios() {
      const limite = this.product?.limiteBeneficiarios ?? 0
      const usados = this.beneficiariosList?.filter(b => b.es_beneficiario).length || 0
      return usados >= limite
    },
    esCrearBeneficiario() {
      return !this.readOnly && !this.beneficiarioId
    },
    escenario() {
      if (!this.product) return 'DESCONOCIDO';
      const esBeneficiario = !!this.product.beneficiario;
      const limiteBeneficiarios = this.product.limiteBeneficiarios || 0;
      const limiteFamiliares = this.product.limiteFamiliares || 0;

      if (!esBeneficiario && limiteFamiliares >= 1) {
        return 'SOLO_FAMILIARES';
      }

      if (esBeneficiario && limiteBeneficiarios >= 1 && limiteFamiliares >= 1) {
        return 'FAMILIARES_Y_BENEFICIARIOS';
      }

      if (esBeneficiario && limiteBeneficiarios >= 1 && limiteFamiliares === 0) {
        return 'SOLO_BENEFICIARIOS';
      }

      if (limiteFamiliares >= 1) return 'SOLO_FAMILIARES';
      return 'DESCONOCIDO';
    },
    rules() {
      const escenarioBase = ESCENARIO_RULES[this.escenario] || {};

      return {
        ...escenarioBase,
        puedeSerFamiliar: escenarioBase.puedeSerFamiliar && !this.sinCupoFamiliares,
        puedeSerBeneficiario: escenarioBase.puedeSerBeneficiario && !this.sinCupoBeneficiarios,
      };
    },
    maxPorcentajePosible() {
      if (!this.beneficiarioId) return 100 - this.currentPorcentaje;
      else {
        let restante = 100 - this.currentPorcentaje;
        return Number(this.beneficioEdicion.porcentaje) + Number(restante);
      }
    },
    parentescoList() {
      if (!this.parentescosRaw.length || !this.escenario) return [];
      const rules = ESCENARIO_RULES[this.escenario] || { filtroParentesco: () => true };
      return this.parentescosRaw.filter(p => rules.filtroParentesco(p, this.form));
    },
    algunCheckSeleccionado() {
      return this.form.es_beneficiario || this.form.es_familiar;
    }

  },
  methods: {
    showWarnModal(msg) {
      this.$toast.info(msg, {
        position: "top-right",
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false
      });
    },
    onlyOneCheckRule() {
      return (
        this.form.es_familiar || this.form.es_beneficiario
      ) || 'Debes seleccionar una opción'
    },
    actualizarRfc() {
      if (
        !this.form.nombre ||
        !this.form.apellido_paterno ||
        !this.form.apellido_materno ||
        !this.form.fecha_nacimiento
      )
        return;
      const arregloNacimiento = String(this.form.fecha_nacimiento || "")
        .split("-")
        .map((e) => Number(e));
      if (arregloNacimiento.length < 3) return;
      const rfc = RfcFacil.forNaturalPerson({
        name: this.form.nombre,
        firstLastName: this.form.apellido_paterno,
        secondLastName: this.form.apellido_materno,
        day: arregloNacimiento[0],
        month: arregloNacimiento[1],
        year: arregloNacimiento[2],
      });
      let edad = this.validateAge();
      if (Number(edad) > 18) this.form.rfc = rfc;
      else this.form.rfc = rfc.substring(0, rfc.length - 3);
    },
    validateAge() {
      const birthDate = moment(this.form.fecha_nacimiento);
      const currentDate = moment();
      const age = currentDate.diff(birthDate, "years");

      return age;
    },
    async getParentescoList() {
      let response = await getParentescoListByAlianzaOrGetNulls(this.alianzaId);
      this.parentescosRaw = response.data;
    },
  },
  mounted() {
  }
};
</script>
